import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/contacts/new/loading';

export const Route = createFileRoute('/_private/contacts/new')({
  pendingComponent: Loading,
});
